// Import controller interfaces
import {
    IIdentityController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import {
    UserMetaData,
} from '@app/models/api';

export default class MockIdentityController implements IIdentityController {

    public constructor() {

    }

	public async getUserMetaData(): Promise<UserMetaData> {
		return new Promise((resolve, reject) => {
			let userMetaData = new UserMetaData();
			userMetaData.UUID = 'XYZ';
			userMetaData.userID = 1;
			userMetaData.username = 'Test Testerson';
			userMetaData.firstName = 'Test';
			userMetaData.lastName = 'Testerson';
			userMetaData.producerId = 1;
			userMetaData.isAdmin = false;
			userMetaData.isUnderwriter = true;
			userMetaData.isProducerAdmin = true;

			setTimeout(() => {
				resolve(userMetaData);
			}, 1000);
		});
    }
};